import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import StatusModal from './StatusModal';
import Paragraph from '../Paragraph/Paragraph';
import { pxToRem } from '../../assets/styles/helper';

const CustomerServiceBody = styled.div`
  width: 100%;
`;

const Message = styled(Paragraph)`
  margin-bottom: ${pxToRem(20)};
`;

const ErrorCode = styled(Paragraph)`
  font-weight: 600;
  margin-bottom: ${pxToRem(4)};
`;

const Phone = styled(Paragraph)`
  margin-bottom: 0;
`;

const CustomerServiceInfoModal = ({
  isOpen,
  close,
  title,
  message,
  errorCode,
  phoneNumber,
  okLabel,
}) => {
  const { t } = useTranslation();

  return (
    <StatusModal
      isOpen={isOpen}
      close={close}
      onButtonClick={close}
      modalTitle={title || t('support.contactCustomerServiceTitle')}
      hideIcon
      primaryButtonLabel={okLabel || t('common.ok')}
      bodyContent={
        <CustomerServiceBody>
          <Message labelColor>
            {message || t('support.contactCustomerServiceMessage')}
          </Message>
          <ErrorCode labelColor>
            {t('support.errorCodeLabel')}: {errorCode || 'SEG-001'}
          </ErrorCode>
          <br />
          <Phone labelColor>{phoneNumber} (toll free)</Phone>
        </CustomerServiceBody>
      }
    />
  );
};

CustomerServiceInfoModal.propTypes = {
  isOpen: PropTypes.bool,
  close: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  errorCode: PropTypes.string,
  phoneNumber: PropTypes.string.isRequired,
  okLabel: PropTypes.string,
};

export default CustomerServiceInfoModal;
